import { render, staticRenderFns } from "./NewReservationButton.vue?vue&type=template&id=6c824a1c&"
import script from "./NewReservationButton.vue?vue&type=script&lang=js&"
export * from "./NewReservationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports